<template>
  <div>
    <div class="mx-auto">
      <div class="bg-white/20 backdrop-blur-md rounded-xl shadow-xl overflow-hidden border border-white/30">
        <div class="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 p-6 text-white">
          <button @click="closePostReport" class="text-blue-100 hover:text-white flex float-left">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
          <h1 class="text-2xl font-bold text-center">ارسال بسته به پست</h1>
          <p class="text-center text-blue-100 mt-2">فایل خود را آپلود کنید و گزارش سفارشی دریافت نمایید</p>
        </div>
        <div
            v-if="popupVisible"
            class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40"
            @click="popupVisible = false"
        ></div>
        <div
            v-if="popupVisible"
            class="fixed z-50 bg-white/90 backdrop-blur-md shadow-lg rounded-lg p-4 border border-gray-200 max-w-xs w-full"
            :style="{
    top: `${popupTopPosition}px`,
    left: '50%',
    transform: 'translateX(-50%)'
  }"
        >
          <div class="text-sm font-medium text-gray-700 mb-3">این ستون را به عنوان:</div>
          <button
              @click.stop="setHeaderType('code')"
              class="block w-full text-right px-4 py-2 text-sm hover:bg-orange-50 text-orange-600 rounded-lg transition-colors"
          >
            کد رهگیری مرسوله
          </button>
          <button
              @click.stop="setHeaderType('order')"
              class="block w-full text-right px-4 py-2 text-sm hover:bg-green-50 text-green-600 rounded-lg mt-2 transition-colors"
          >
            شماره سفارش
          </button>
          <button
              @click.stop="popupVisible = false"
              class="block w-full text-right px-4 py-2 text-sm hover:bg-gray-100 text-gray-600 rounded-lg mt-3 transition-colors"
          >
            انصراف
          </button>
        </div>

        <div class="px-8 pt-6">
          <div class="flex items-center justify-between relative">
            <!-- Step 1: Upload -->
            <div class="flex flex-col items-center z-10 cursor-pointer" @click="resetForm">
              <div :class="[
                'hover:bg-blue-400 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                rows.length ? 'bg-green-500' : 'bg-blue-500'
              ]">
                1
              </div>
              <span class="mt-2 text-sm font-medium">آپلود فایل</span>
            </div>

            <!-- Connector line -->
            <div class="absolute h-1 w-full bg-gray-200 top-5"></div>
            <div
                :class="[
                'absolute h-1 bg-blue-500 top-5 transition-all duration-500',
                rows.length ? 'w-full' : 'w-0'
              ]"
            ></div>

            <!-- Step 2: Preview -->
            <div class="flex flex-col items-center z-10">
              <div :class="[
                'w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                rows.length ? 'bg-blue-500' : 'bg-gray-300'
              ]">
                2
              </div>
              <span class="mt-2 text-sm font-medium">پیش نمایش داده‌ها</span>
            </div>

            <!-- Step 3: Generate -->
            <div class="flex flex-col items-center z-10">
              <div :class="[
                'w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                reportResult ? 'bg-green-500' : rows.length ? 'bg-gray-300' : 'bg-gray-300'
              ]">
                3
              </div>
              <span class="mt-2 text-sm font-medium">تولید گزارش</span>
            </div>
          </div>
        </div>

        <!-- Main content -->
        <div class="p-8">
          <div v-if="!rows.length" class="transition-all duration-300 cursor-pointer hover:bg-blue-50 rounded-xl">
            <div
                class="border-2 border-dashed border-blue-300 rounded-xl bg-white/50 p-8 text-center"
                @click="openFileDialog"
                @dragover.prevent="dragover = true"
                @dragleave="dragover = false"
                @drop.prevent="handleDrop"
                :class="{'border-blue-500 bg-blue-50/50': dragover}"
            >
              <div class="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                </svg>
              </div>
              <h3 class="text-lg font-medium text-gray-800">فایل اکسل خود را اینجا رها کنید</h3>
              <p class="mt-1 text-sm text-gray-500">یا برای انتخاب فایل کلیک کنید</p>

              <!-- Hidden file input -->
              <input
                  type="file"
                  ref="fileInput"
                  accept=".xls,.xlsx"
                  @change="handleFileChange"
                  class="hidden"
              />

              <p v-if="selectedFile" class="mt-4 text-sm text-green-600 font-medium">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block mr-1" viewBox="0 0 20 20"
                     fill="currentColor">
                  <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"/>
                </svg>
                فایل انتخاب شده: {{ selectedFile.name }}
              </p>

              <div v-if="loading" class="mt-6">
                <div class="flex flex-col items-center">
                  <svg class="animate-spin h-8 w-8 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                       viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span class="text-sm text-gray-600">در حال آپلود فایل...</span>
                </div>
              </div>

              <div v-if="error" class="mt-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                {{ error }}
              </div>
            </div>
          </div>
          <div v-if="rows.length" class="transition-all duration-300">
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div class="p-4 border-b border-gray-200 bg-gray-50">
                <h2 class="text-lg font-semibold text-gray-800">پیش نمایش داده‌های استخراج شده</h2>

                <div class="mt-4 grid grid-cols-3 md:grid-cols-3 gap-4" v-if="!reportResult">
                  <div class="mt-2">
                    <label class=" text-xs font-medium text-gray-700 mb-1">ستون شماره سفارش</label>
                    <select
                        v-model="selectedOrderHeader"
                        class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-center"
                    >
                      <option v-for="h in headers" :key="h" :value="h">{{ headerLabel(h) }}</option>
                    </select>
                  </div>
                  <div class="mt-2">
                    <label class=" text-xs font-medium text-gray-700 mb-1">ستون کد رهگیری مرسوله</label>
                    <select
                        v-model="selectedCodeHeader"
                        class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-center"
                    >
                      <option v-for="h in headers" :key="h" :value="h">{{ headerLabel(h) }}</option>
                    </select>
                  </div>
                  <div class=" flex justify-end" v-if="!reportResult">
                    <button
                        @click="createExtractedReport"
                        :disabled="!canCreateReport || creatingReport"
                        :class="[
                      'px-3 py-1 rounded-lg font-medium transition-all flex items-center text-center',
                      canCreateReport && !creatingReport
                        ? 'bg-green-600 text-white shadow-md hover:bg-green-700 hover:shadow-lg'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    ]"
                    >
                    <span v-if="creatingReport">
                      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block"
                           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      در حال ساخت گزارش...
                    </span>
                      <span v-else>
                      تولید گزارش نهایی
                    </span>
                    </button>
                  </div>

                </div>
                <div
                    v-if="reportResult"
                    class="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start"
                >
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd"/>
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-sm font-medium text-green-800">عملیات با موفقیت انجام شد</h3>
                    <div class="mt-1 text-sm text-green-700">
                      <p>شناسه گزارش:
                        <span class="font-mono font-bold">{{ reportResult.report_id }}</span>
                      </p>
                      <p>تعداد آیتم‌های ایجاد شده: <span class="font-mono">{{ reportResult.items_created }}</span></p>
                      <p class="text-blue-600">تعداد سفارش های ارسال شده: <span
                          class="font-mono font-bold text-blue-600">{{ reportResult.order_shipped }}</span></p>
                      <p class="text-red-600">تعداد ردیف های نامشخص:

                        <span class="font-mono text-red-600 font-bold">{{ reportResult.rows_created }}</span>
                        <router-link
                            target="_blank"
                            to="/panel/extractedPostReportList"
                            class="text-red-600 hover:text-red-800 hover:underline"
                        >
                          <button class="rounded-xl bg-red-700 text-white px-2 py-1 text-xs mr-3">مشاهده</button>

                        </router-link>
                      </p>
                    </div>
                    <div class="mt-3">
                      <button
                          type="button"
                          @click="resetForm"
                          class="inline-flex items-center text-sm font-medium text-green-700 hover:text-green-600"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="-ml-0.5 mr-1 h-4 w-4" fill="none"
                             viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                        </svg>
                        آپلود فایل جدید
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              <div class="overflow-x-auto" v-if="!reportResult">
                <table class="min-w-full divide-y divide-gray-200" v-if="rows && rows.length">
                  <thead class="bg-gray-100">
                  <tr>
                    <th
                        @click="showHeaderPopup(h)"
                        v-for="h in headers"
                        :key="h"
                        scope="col"
                        class="text-center items-center px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase cursor-pointer hover:bg-blue-200 hover:text-white"
                    >
                      <div class="flex items-center justify-between">
                        <span v-if="h !== selectedCodeHeader && h !== selectedOrderHeader"
                              class="m-[auto] ">{{ headerLabel(h) }}</span>
                        <span v-if="h === selectedCodeHeader"
                              class="justify-center m-[auto] bg-orange-100 text-orange-600 text-xs px-2 py-0.5 rounded-full">کد رهگیری مرسوله</span>
                        <span v-if="h === selectedOrderHeader"
                              class=" justify-center m-[auto]  bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full">سفارش</span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(row, i) in rows.slice(0, 10)" :key="i" class="hover:bg-gray-50">
                    <td
                        v-for="h in headers"
                        :key="h"
                        class=" text-xs text-gray-800 text-opacity-50 hover:bg-blue-200 hover:text-white text-center py-2"
                        :class="{
                              'font-medium text-orange-500 text-opacity-100 ': h === selectedCodeHeader,
                              'font-medium text-green-600 text-opacity-100 ': h === selectedOrderHeader,
                              'cursor-pointer': !popupVisible
                            }"
                        @click="showHeaderPopup(h)"
                    >
                      <span>
                        {{ row && row[h] !== undefined ? row[h] : '' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="rows.length > 10">
                    <td :colspan="headers.length" class="px-4 py-3 text-center text-sm text-gray-500">
                      و {{ rows.length - 10 }} رکورد دیگر ...
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HandlePostReport',
  data() {
    return {
      popupVisible: false,
      clickedHeader: null,
      selectedFile: null,
      formatType: 'indexed_dict',
      startCol: 1,
      loading: false,
      error: '',
      rows: [],
      headers: [],
      popupTopPosition: 100,
      uploadedFileId: null,
      selectedCodeHeader: null,
      selectedOrderHeader: null,
      creatingReport: false,
      reportResult: null,
      dragover: false,
    };
  },
  computed: {
    canCreateReport() {
      return this.uploadedFileId && this.selectedCodeHeader && this.selectedOrderHeader;
    }
  },
  methods: {
    openFileDialog() {
      this.$refs.fileInput.click();
    },

    handleDrop(e) {
      this.dragover = false;
      if (e.dataTransfer.files.length) {
        this.selectedFile = e.dataTransfer.files[0];
        this.uploadFile(); // Automatically upload when file is dropped
      }
    },

    resetForm() {
      this.selectedFile = null;
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;
    },

    headerLabel(h) {
      const num = parseInt(h);
      if (!isNaN(num)) return `ستون ${num}`;
      return h;
    },

    handleFileChange(e) {
      this.selectedFile = e.target.files[0];
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;
      this.uploadFile();

    },

    async uploadFile() {
      if (!this.selectedFile) {
        this.error = 'لطفاً فایل انتخاب کنید.';
        return;
      }
      this.loading = true;
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;

      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('format_type', this.formatType);
        formData.append('start_col', this.startCol);

        this.request({
          url: this.endpoint('file_handler/upload'),
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          success: (data) => {
            this.uploadedFileId = data.id || null;

            if (!data.rows || !Array.isArray(data.rows)) {
              throw new Error('پاسخ سرور شامل rows نیست.');
            }
            this.rows = data.rows;

            const allKeys = new Set();
            this.rows.forEach(r => Object.keys(r).forEach(k => allKeys.add(k)));
            this.headers = Array.from(allKeys).sort((a, b) => {
              const an = parseInt(a), bn = parseInt(b);
              if (!isNaN(an) && !isNaN(bn)) return an - bn;
              if (!isNaN(an)) return -1;
              if (!isNaN(bn)) return 1;
              return a.localeCompare(b);
            });

            if (this.headers.length) {
              this.selectedCodeHeader =
                  this.headers.find(h => h === '2' || h.toLowerCase().includes('code')) ||
                  this.headers[1] || this.headers[0];
              this.selectedOrderHeader =
                  this.headers.find(h => h === '1' || h.toLowerCase().includes('order')) ||
                  this.headers[0] || this.headers[1] || this.headers[0];
            }
          },
          error: (err) => {
            this.error = err?.error || 'خطا در آپلود فایل';
          }
        });

      } catch (err) {
        this.error = err.message || 'خطا رخ داد';
      } finally {
        this.loading = false;
      }
    },

    headerToColumnNumber(header) {
      const parsed = parseInt(header);
      if (!isNaN(parsed)) return parsed;

      const idx = this.headers.indexOf(header);
      if (idx === -1) return null;
      return this.startCol + idx;
    },
    closePostReport() {
      this.$emit('close');
    },

    createExtractedReport() {
      this.loading = true
      if (!this.canCreateReport) return;
      this.creatingReport = true;
      this.error = '';
      this.reportResult = null;

      try {
        const codeCol = this.headerToColumnNumber(this.selectedCodeHeader);
        const orderCol = this.headerToColumnNumber(this.selectedOrderHeader);

        if (!codeCol || !orderCol) {
          throw new Error('نتوانستم شماره ستون را محاسبه کنم. لطفاً دوباره ستون‌ها را بررسی کنید.');
        }

        const body = {
          file_id: this.uploadedFileId,
          post_tracking_code: codeCol,
          order: orderCol
        };

        this.request({
          url: this.endpoint('file_handler/extract'),
          method: 'post',
          data: body,
          success: (result) => {
            this.reportResult = result;
            this.loading = false
            this.creatingReport = false;
          },
          error: (err) => {
            this.error = err?.detail || err?.error || 'خطا در ساخت گزارش';
          }
        });

      } catch (err) {
        this.error = err.message || 'خطا رخ داد';
      } finally {
        this.creatingReport = false;
        this.loading = false
      }
    },
    showHeaderPopup(header) {
      this.clickedHeader = header;
      this.popupTopPosition = window.scrollY + 100;
      this.popupVisible = true;
    },
    setHeaderType(type) {
      if (type === 'code') {
        if (this.selectedOrderHeader === this.clickedHeader) {
          this.selectedOrderHeader = null
        }
        this.selectedCodeHeader = this.clickedHeader;
      } else if (type === 'order') {
        if (this.selectedCodeHeader === this.clickedHeader) {
          this.selectedCodeHeader = null
        }
        this.selectedOrderHeader = this.clickedHeader;
      }
      this.popupVisible = false;
    },
    handleClickOutsidePopup(e) {
      if (!this.$el.contains(e.target)) {
        this.popupVisible = false;
      }
    },
    updatePopupPosition() {
      if (this.popupVisible) {
        this.popupTopPosition = window.scrollY + 100;
      }
    },


  },
  mounted() {
    window.addEventListener('scroll', this.updatePopupPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updatePopupPosition);
  },

};
</script>

<style scoped>
.table-enter-active, .table-leave-active {
  transition: opacity 0.3s ease;
}

.table-enter-from, .table-leave-to {
  opacity: 0;
}

/* Transition effects */
.popup-enter-active,
.popup-leave-active {
  transition: all 0.2s ease;
}

.popup-enter-from,
.popup-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity 0.2s ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

</style>